/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/iframe-has-title */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react/button-has-type */
/* eslint-disable consistent-return */
import React, { FunctionComponent, useEffect, useRef, useState } from 'react';
import { useParams } from 'react-router-dom';
import { TransformComponent, TransformWrapper } from 'react-zoom-pan-pinch';
import { Stack } from '@mui/material';
import classes from './LictionDiv.module.css';
import { LectionSlideDto } from '../../dto/LectionImageDto';
import { RESOURCE_URL } from '../../setting/AppSettings';
import {
  findBase64Image,
  GetDarkVideoName,
  getImageVideoSize,
  getImgWidthVideo,
  getImgWidthVideoKines,
  GetLightOrDarkVideoName,
  getMaxHeightConst,
  getMaxHeightConst2,
  getPosition,
  GetPosterName,
  GetVideoUrlToTheme,
  HasVideoUrlToTheme,
  secureContent,
} from '../../utils/utils';
import {
  DARK_THEME,
  IMAGE_TYPE,
  IMAGE_TYPE_BASE_AND_SELECT,
  IMAGE_TYPE_BASE_AND_SELECT_WITH_BLACK,
  IMAGE_TYPE_CROP,
  IMAGE_TYPE_MANY,
  IMAGE_TYPE_VIDEO,
  IMAGE_TYPE_VIDEO_POSTER,
  IMAGE_TYPE_ZOOM,
  IMAGE_TYPE_ZOOM_VIDEO,
  IMAGE_TYPE_ZOOM_WITH_BLACK,
  LIGHT_THEME,
  SYSTEM_THEME,
  WINDOW_H,
  WINDOW_V,
} from '../../constant/constants';
import ImageGo from '../../image/Go-back_Light.png';
import ImageGo2 from '../../image/Go-back_Dark.png';
import { HelpZoomImageDto } from '../../dto/HelpZoomImageDto';
import { ImageBase6444Dto } from '../../dto/ImageBase6444Dto';

interface Props {
  curTheme: number;
  step: number;
  slide: number;
  dto: LectionSlideDto;
  isZoom: boolean;
  windowState: number;
  dtoImagesBase6444?: ImageBase6444Dto[];
  videoSize: string;
}

/*
  --ease-in-quad: cubic-bezier(0.55, 0.085, 0.68, 0.53);

  --ease-in-cubic: cubic-bezier(0.55, 0.055, 0.675, 0.19);

  --ease-in-quart: cubic-bezier(0.895, 0.03, 0.685, 0.22);

  --ease-in-quint: cubic-bezier(0.755, 0.05, 0.855, 0.06);

  --ease-in-expo: cubic-bezier(0.95, 0.05, 0.795, 0.035);

  --ease-in-circ: cubic-bezier(0.6, 0.04, 0.98, 0.335);

  --ease-out-quad: cubic-bezier(0.25, 0.46, 0.45, 0.94);

  --ease-out-cubic: cubic-bezier(0.215, 0.61, 0.355, 1);

  --ease-out-quart: cubic-bezier(0.165, 0.84, 0.44, 1);

  --ease-out-quint: cubic-bezier(0.23, 1, 0.32, 1);

  --ease-out-expo: cubic-bezier(0.19, 1, 0.22, 1);

  --ease-out-circ: cubic-bezier(0.075, 0.82, 0.165, 1);

  --ease-in-out-quad: cubic-bezier(0.455, 0.03, 0.515, 0.955);

  --ease-in-out-cubic: cubic-bezier(0.645, 0.045, 0.355, 1);

  --ease-in-out-quart: cubic-bezier(0.77, 0, 0.175, 1);

  --ease-in-out-quint: cubic-bezier(0.86, 0, 0.07, 1);

  --ease-in-out-expo: cubic-bezier(1, 0, 0, 1);

  --ease-in-out-circ: cubic-bezier(0.785, 0.135, 0.15, 0.86);

  */

export const LectionDivImageItem: FunctionComponent<Props> = ({
  curTheme,
  step,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  slide,
  dto,
  dtoImagesBase6444,
  isZoom,
  windowState,
  videoSize,
}) => {
  const { section, lectionId } = useParams();
  const [zoomSize, setZoomSize] = useState(1);

  const btnRef = useRef<HTMLButtonElement>(null);
  const btnRef2 = useRef<HTMLButtonElement>(null);

  const API_VERSION = '5';

  const [helpZoomImageDto, setHelImageDtopDto] = useState<HelpZoomImageDto>({
    initZoom: 1,
    zoom: 1,
    x: windowState === WINDOW_V ? window.innerWidth / 2 : window.innerWidth / 4,
    y:
      windowState === WINDOW_V
        ? getMaxHeightConst() / 2
        : getMaxHeightConst2() / 4,
  });

  const animationDivHandler = () => {
    const divAnimation = document.getElementById(`img`);
    if (divAnimation !== null) {
      divAnimation.classList.remove(classes.img);
    }
  };

  const animationDiv = () => {
    const divAnimation = document.getElementById(`img`);
    if (divAnimation !== null) {
      divAnimation.classList.add(classes.img);
      divAnimation.addEventListener('animationend', animationDivHandler, false);
      return () => {
        divAnimation.removeEventListener(
          'animationend',
          animationDivHandler,
          false
        );
      };
    }
  };

  // Внутри вашего компонента добавьте:
  const [showReplay, setShowReplay] = useState(false);
  const videoRef = useRef<HTMLVideoElement>(null);

  // Функция для перезапуска видео
  const handleReplay = () => {
    if (videoRef.current) {
      videoRef.current.currentTime = 0;
      videoRef.current.play();
      setShowReplay(false);
    }
  };

  const [isProgress, setProgress] = useState(true);

  // Функция для обработки конца видео
  const handleVideoEnd = () => {
    setShowReplay(true);
  };

  const [zoomKoeff, setZoomKoeff] = useState(1);
  const [tranformValue, setTransformValue] = useState('translate(0px, 0px)');

  useEffect(() => {
    setTransformValue('translate3d(0px, 0px)');
    if (btnRef.current === null) {
      animationDiv();
    }
    if (
      dto.slideImages[step].type === IMAGE_TYPE_ZOOM ||
      dto.slideImages[step].type === IMAGE_TYPE_ZOOM_WITH_BLACK ||
      dto.slideImages[step].type === IMAGE_TYPE_ZOOM_VIDEO
    ) {
      if (isZoom) {
        const coordinateArr =
          dto.slideImages[step].zoomImage.coordinate.split('**');

        const widthZoom = coordinateArr[0];
        const heightZoom = coordinateArr[1];

        let coeffNurlat = 0.95;
        if (
          dto.slideImages[step].zoomImage.width !== undefined &&
          dto.slideImages[step].zoomImage.height !== undefined
        ) {
          /*
          const coeffNurlat2 =
            dto.slideImages[step].zoomImage.width /
            dto.slideImages[step].zoomImage.height;
          const apprZommX =
            (-0.8 * parseFloat(widthZoom)) /
              dto.slideImages[step].zoomImage.width +
            1.33;
          const apprZommY =
            ((-0.8 * parseFloat(heightZoom)) /
              dto.slideImages[step].zoomImage.height +
              1.3) *
            coeffNurlat2;

          coeffNurlat = apprZommX;
          if (coeffNurlat > apprZommY) {
            coeffNurlat = apprZommY;
          }
          if (coeffNurlat > 0.95) {
            // coeffNurlat = 0.95;
          }
          if (coeffNurlat < (0.25 * window.innerWidth) / 375) {
            coeffNurlat = (0.25 * window.innerWidth) / 375;
          }
          */
          coeffNurlat = window.innerWidth / parseFloat(widthZoom);
          let newCoefNurlayNew2 =
            window.innerHeight / 2 / parseFloat(heightZoom);
          if (newCoefNurlayNew2 < coeffNurlat) {
            coeffNurlat = newCoefNurlayNew2;
          }
          if (windowState === WINDOW_H) {
            coeffNurlat = window.innerWidth / 2 / parseFloat(widthZoom);
            newCoefNurlayNew2 = window.innerHeight / parseFloat(heightZoom);
            if (newCoefNurlayNew2 < coeffNurlat) {
              coeffNurlat = newCoefNurlayNew2;
            }
          }
          coeffNurlat *= 0.9;
        }

        const zoomNew = dto.slideImages[step].zoomImage.zoom * coeffNurlat;
        setZoomSize(zoomNew);

        const xZoom =
          parseInt(coordinateArr[2], 10) + parseInt(widthZoom, 10) / 2;
        const yZoom =
          parseInt(coordinateArr[3], 10) + parseInt(heightZoom, 10) / 2;

        const widthImageFormat = dto.slideImages[step].zoomImage.width / 2;
        const heightImaheFormat = dto.slideImages[step].zoomImage.height / 2;

        const diffX = widthImageFormat - xZoom;
        const diffY = heightImaheFormat - yZoom;

        const imageArr = getImageVideoSize(
          dto.slideImages[step].zoomImage,
          windowState === WINDOW_V ? getMaxHeightConst() : getMaxHeightConst2(),
          windowState === WINDOW_V ? window.innerWidth : window.innerWidth / 2
        );

        let zoomInitW = 1;
        let zoomInitHe = 1;
        if (dto.slideImages[step].zoomImage.width !== undefined) {
          zoomInitW =
            imageArr[0] / dto.slideImages[step].zoomImage.width / zoomNew;
        }
        if (dto.slideImages[step].zoomImage.height !== undefined) {
          zoomInitHe =
            imageArr[1] / dto.slideImages[step].zoomImage.height / zoomNew;
        }
        /*
        console.log(
          `${step} ${dto.slideImages[step].zoomImage.width} ${dto.slideImages[step].zoomImage.height} ${zoomNew} ${imageArr[0]} ${imageArr[1]}`
        );
        */
        let minZoom = zoomInitW;
        if (minZoom > zoomInitHe) {
          minZoom = zoomInitHe;
        }
        setZoomKoeff(zoomInitW);

        let difXnew = Math.round(diffX * zoomNew * zoomInitW);
        let difYnew = Math.round(diffY * zoomNew * zoomInitW);
        const zoomInitWNew = Number((1 / zoomInitW).toFixed(1));

        if (difXnew % 2 !== 0) {
          difXnew += 1;
        }
        if (difYnew % 2 !== 0) {
          difYnew += 1;
        }

        /*
        console.log(
          `${isZoom} ${coeffNurlat} ${zoomInitWNew} ${difXnew} ${difYnew}`
        );
        console.log(
          `scale(${zoomInitWNew}) translate(${difXnew}px, ${difYnew}px)`
        );
        */

        setTransformValue(
          `scale(${zoomInitWNew}) translate(${difXnew}px, ${difYnew}px)`
        );

        setHelImageDtopDto({
          initZoom: 1,
          zoom: 1,
          x: diffX * zoomNew,
          y: diffY * zoomNew,
        });
      } else {
        const imageArr = getImageVideoSize(
          dto.slideImages[step].zoomImage,
          windowState === WINDOW_V ? getMaxHeightConst() : getMaxHeightConst2(),
          windowState === WINDOW_V ? window.innerWidth : window.innerWidth / 2
        );

        let zoomInitW = 1;
        let zoomInitHe = 1;
        if (dto.slideImages[step].zoomImage.width !== undefined) {
          zoomInitW =
            imageArr[0] / dto.slideImages[step].zoomImage.width / zoomSize;
        }
        if (dto.slideImages[step].zoomImage.height !== undefined) {
          zoomInitHe =
            imageArr[1] / dto.slideImages[step].zoomImage.height / zoomSize;
        }

        let minZoom = zoomInitW;
        if (minZoom > zoomInitHe) {
          minZoom = zoomInitHe;
        }

        setZoomKoeff(1);

        setHelImageDtopDto({
          initZoom: zoomInitW,
          zoom: 1,
          x: 0,
          y: 0,
        });
      }

      // eslint-disable-next-line react-hooks/exhaustive-deps
    } else {
      setHelImageDtopDto({
        initZoom: 1,
        zoom: 1,
        x: 0,
        y: 0,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [step, slide, isZoom, zoomSize, tranformValue]);

  useEffect(() => {
    if (
      dto.slideImages[step].type === IMAGE_TYPE_ZOOM ||
      dto.slideImages[step].type === IMAGE_TYPE_ZOOM_WITH_BLACK ||
      dto.slideImages[step].type === IMAGE_TYPE_ZOOM_VIDEO
    ) {
      if (isZoom) {
        btnRef2?.current?.click();
      } else {
        btnRef2?.current?.click();
      }
    } else {
      btnRef2?.current?.click();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [helpZoomImageDto, isZoom]);

  useEffect(() => {
    setShowReplay(false);
    setProgress(true);
    setTransformValue('translate(0px, 0px)');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [step, slide]);

  return (
    <div id="img">
      {showReplay && (
        <div
          style={{
            position: 'absolute',
            top: windowState === WINDOW_V ? 15 : undefined,
            right: windowState === WINDOW_V ? 12 : 'calc(50% + 12px)',
            left: windowState === WINDOW_V ? undefined : undefined,
            bottom: windowState === WINDOW_V ? undefined : 15,
            zIndex: 10,
            width: '52px',
            height: '42px',
            borderRadius: '34px',
            alignItems: 'end',
            justifyContent: 'center',
            justifyItems: 'center',
            background:
              curTheme === LIGHT_THEME
                ? '#FFFFFF' // Для светлой темы
                : '#404952',
          }}
          onClick={handleReplay}
        >
          <Stack
            width="100%"
            height="100%"
            alignItems="center"
            justifyContent="center"
          >
            <img
              alt=""
              width="32px"
              src={curTheme === LIGHT_THEME ? ImageGo : ImageGo2}
            />
          </Stack>
        </div>
      )}
      {isProgress &&
        (dto.slideImages[step].type === IMAGE_TYPE_ZOOM_VIDEO ||
          dto.slideImages[step].type === IMAGE_TYPE_VIDEO) && (
          <div
            style={{
              position: 'absolute',
              top: windowState === WINDOW_V ? 15 : undefined,
              right: windowState === WINDOW_V ? 12 : 'calc(50% + 12px)',
              left: windowState === WINDOW_V ? undefined : undefined,
              bottom: windowState === WINDOW_V ? undefined : 15,
              zIndex: 10,
              width: '52px',
              height: '42px',
              borderRadius: '34px',
              alignItems: 'end',
              justifyContent: 'center',
              justifyItems: 'center',
              background: curTheme === LIGHT_THEME ? '#FFFFFF' : '#404952',
            }}
          >
            <Stack
              width="100%"
              height="100%"
              alignItems="center"
              justifyContent="center"
            >
              <div
                style={{
                  width: '17px',
                  height: '17px',
                  border: `2px solid ${
                    curTheme === LIGHT_THEME ? '#CDD7DF' : '#848D95'
                  }`,
                  borderTop: `2px solid ${
                    curTheme === LIGHT_THEME ? '#FFFFFF' : '#404952'
                  }`,
                  borderRadius: '50%',
                  animation: 'spin 1s linear infinite',
                }}
              />
              <style>
                {`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}
              </style>
            </Stack>
          </div>
        )}

      <div hidden={!(dto.slideImages[step].type === IMAGE_TYPE_VIDEO_POSTER)}>
        <Stack
          width={
            windowState === WINDOW_V ? window.innerWidth : window.innerWidth / 2
          }
          height={
            windowState === WINDOW_V
              ? getMaxHeightConst()
              : getMaxHeightConst2()
          }
          alignItems="center"
          justifyContent="center"
        >
          <div
            style={{
              position: 'relative',
              width: getImgWidthVideoKines(),
              height: getImgWidthVideoKines(),
              overflow: 'hidden',
              backgroundImage:
                findBase64Image(
                  GetPosterName(
                    dto.slideImages[step].descr,
                    curTheme,
                    dto.videoMetadata
                  ),
                  dtoImagesBase6444
                ) !== ''
                  ? `url(data:image/png;base64,${findBase64Image(
                      GetPosterName(
                        dto.slideImages[step].descr,
                        curTheme,
                        dto.videoMetadata
                      ),
                      dtoImagesBase6444
                    )})`
                  : `url('https://uchianat.ru/api/contentUrl.php?section=${section}&lectionId=${lectionId}&page=${
                      dto.id
                    }&type=1&name=${GetPosterName(
                      dto.slideImages[step].descr,
                      curTheme,
                      dto.videoMetadata
                    )}&${secureContent()}')`,
              backgroundSize: 'cover',
              backgroundPosition: 'center',
              backgroundRepeat: 'no-repeat',
            }}
          >
            {' '}
          </div>
        </Stack>
      </div>

      <div
        hidden={
          !(
            dto.slideImages[step].type === IMAGE_TYPE ||
            dto.slideImages[step].type === IMAGE_TYPE_MANY
          )
        }
      >
        <TransformWrapper>
          <TransformComponent>
            <Stack
              width={
                windowState === WINDOW_V
                  ? window.innerWidth
                  : window.innerWidth / 2
              }
              height={
                windowState === WINDOW_V
                  ? getMaxHeightConst()
                  : getMaxHeightConst2()
              }
              alignItems="center"
              justifyContent="center"
              sx={{
                overflow: 'hidden', // важно для iOS
                position: 'relative',
                backgroundColor: 'transparent',
              }}
            >
              {dto.slideImages[step].images.map((item) => (
                <img
                  key={item.name}
                  className={classes.img}
                  style={{
                    position: getPosition(dto.slideImages[step].type, false),
                    filter:
                      item.fill === 0 ? 'grayscale(0%)' : 'grayscale(100%)',
                  }}
                  width={
                    getImageVideoSize(
                      item,
                      windowState === WINDOW_V
                        ? getMaxHeightConst()
                        : getMaxHeightConst2(),
                      windowState === WINDOW_V
                        ? window.innerWidth
                        : window.innerWidth / 2
                    )[0]
                  }
                  height={
                    getImageVideoSize(
                      item,
                      windowState === WINDOW_V
                        ? getMaxHeightConst()
                        : getMaxHeightConst2(),
                      windowState === WINDOW_V
                        ? window.innerWidth
                        : window.innerWidth / 2
                    )[1]
                  }
                  src={
                    findBase64Image(item.name, dtoImagesBase6444) !== ''
                      ? `data:image/png;base64,${findBase64Image(
                          item.name,
                          dtoImagesBase6444
                        )}`
                      : `https://uchianat.ru/api/contentUrl.php?section=${section}&lectionId=${lectionId}&page=${
                          dto.id
                        }&name=${item.name}&${secureContent()}`
                  }
                  alt="not found"
                />
              ))}
            </Stack>
          </TransformComponent>
        </TransformWrapper>
      </div>
      <div hidden={!(dto.slideImages[step].type === IMAGE_TYPE_VIDEO)}>
        {dto.slideImages[step].images.map((item) => (
          <Stack
            width={
              windowState === WINDOW_V
                ? window.innerWidth
                : window.innerWidth / 2
            }
            height={
              windowState === WINDOW_V
                ? getMaxHeightConst()
                : getMaxHeightConst2()
            }
            alignItems="center"
            justifyContent="center"
          >
            <div
              style={{
                position: 'relative',
                width: getImgWidthVideoKines(),
                height: getImgWidthVideoKines(),
                overflow: 'hidden',
                backgroundImage:
                  findBase64Image(
                    GetPosterName(item.name, curTheme, dto.videoMetadata),
                    dtoImagesBase6444
                  ) !== ''
                    ? `url(data:image/png;base64,${findBase64Image(
                        GetPosterName(item.name, curTheme, dto.videoMetadata),
                        dtoImagesBase6444
                      )})`
                    : `url('https://uchianat.ru/api/contentUrl.php?section=${section}&lectionId=${lectionId}&page=${
                        dto.id
                      }&type=1&name=${GetPosterName(
                        item.name,
                        curTheme,
                        dto.videoMetadata
                      )}&${secureContent()}')`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat',
              }}
            >
              <video
                key={`${item.name}-${curTheme}-${videoSize}-${API_VERSION}`}
                ref={videoRef}
                width={getImgWidthVideoKines()}
                height={getImgWidthVideoKines()}
                playsInline
                autoPlay
                muted
                preload="metadata"
                poster="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"
                controls={false}
                onEnded={handleVideoEnd}
                onPlay={() => {
                  setShowReplay(false);
                  setProgress(false);
                }}
                style={{
                  border: 'none',
                  outline: 'none',
                  margin: 0,
                  width: '100%',
                  height: '100%',
                  padding: 0,
                  // Решаем проблему с черными границами в iOS
                  WebkitMaskImage: '-webkit-radial-gradient(white, black)',
                  borderRadius: '0px !important',
                  backfaceVisibility: 'hidden',
                }}
              >
                <source
                  src={`https://uchianat.ru/api/contentUrl.php?section=${section}&lectionId=${lectionId}&page=${
                    dto.id
                  }&apiVersion=${API_VERSION}&quality=${videoSize}&type=2&realName=${
                    item.name
                  }&name=${GetLightOrDarkVideoName(
                    item.name,
                    curTheme,
                    dto.videoMetadata
                  )}&${secureContent()}`}
                  type="video/mp4"
                />
              </video>
            </div>
          </Stack>
        ))}
      </div>
      <div
        hidden={
          !(
            dto.slideImages[step].type === IMAGE_TYPE_BASE_AND_SELECT ||
            dto.slideImages[step].type ===
              IMAGE_TYPE_BASE_AND_SELECT_WITH_BLACK ||
            dto.slideImages[step].type === IMAGE_TYPE_CROP
          )
        }
      >
        <TransformWrapper>
          <TransformComponent>
            <Stack
              width={
                windowState === WINDOW_V
                  ? window.innerWidth
                  : window.innerWidth / 2
              }
              height={
                windowState === WINDOW_V
                  ? getMaxHeightConst()
                  : getMaxHeightConst2()
              }
              alignItems="center"
              justifyContent="center"
            >
              {isZoom &&
                dto.slideImages[step].images.map((item) => (
                  <img
                    key={item.name}
                    className={classes.img}
                    style={{
                      position: getPosition(dto.slideImages[step].type, false),
                      filter:
                        item.fill === 0 ? 'grayscale(0%)' : 'grayscale(100%)',
                    }}
                    width={
                      getImageVideoSize(
                        item,
                        windowState === WINDOW_V
                          ? getMaxHeightConst()
                          : getMaxHeightConst2(),
                        windowState === WINDOW_V
                          ? window.innerWidth
                          : window.innerWidth / 2
                      )[0]
                    }
                    height={
                      getImageVideoSize(
                        item,
                        windowState === WINDOW_V
                          ? getMaxHeightConst()
                          : getMaxHeightConst2(),
                        windowState === WINDOW_V
                          ? window.innerWidth
                          : window.innerWidth / 2
                      )[1]
                    }
                    src={
                      findBase64Image(item.name, dtoImagesBase6444) !== ''
                        ? `data:image/png;base64,${findBase64Image(
                            item.name,
                            dtoImagesBase6444
                          )}`
                        : `https://uchianat.ru/api/contentUrl.php?section=${section}&lectionId=${lectionId}&page=${
                            dto.id
                          }&name=${item.name}&${secureContent()}`
                    }
                    alt="not found"
                  />
                ))}
              {!isZoom && (
                <img
                  className={classes.img}
                  width={
                    getImageVideoSize(
                      dto.slideImages[step].zoomImage,
                      windowState === WINDOW_V
                        ? getMaxHeightConst()
                        : getMaxHeightConst2(),
                      windowState === WINDOW_V
                        ? window.innerWidth
                        : window.innerWidth / 2
                    )[0]
                  }
                  height={
                    getImageVideoSize(
                      dto.slideImages[step].zoomImage,
                      windowState === WINDOW_V
                        ? getMaxHeightConst()
                        : getMaxHeightConst2(),
                      windowState === WINDOW_V
                        ? window.innerWidth
                        : window.innerWidth / 2
                    )[1]
                  }
                  src={
                    findBase64Image(
                      dto.slideImages[step].zoomImage.name,
                      dtoImagesBase6444
                    ) !== ''
                      ? `data:image/png;base64,${findBase64Image(
                          dto.slideImages[step].zoomImage.name,
                          dtoImagesBase6444
                        )}`
                      : `https://uchianat.ru/api/contentUrl.php?section=${section}&lectionId=${lectionId}&page=${
                          dto.id
                        }&name=${
                          dto.slideImages[step].zoomImage.name
                        }&${secureContent()}`
                  }
                  alt="not found"
                />
              )}
            </Stack>
          </TransformComponent>
        </TransformWrapper>
      </div>
      <div
        hidden={
          !(
            dto.slideImages[step].type === IMAGE_TYPE_ZOOM ||
            dto.slideImages[step].type === IMAGE_TYPE_ZOOM_WITH_BLACK ||
            dto.slideImages[step].type === IMAGE_TYPE_ZOOM_VIDEO
          )
        }
      >
        <TransformWrapper
          initialScale={1}
          initialPositionX={0}
          initialPositionY={0}
          minScale={isZoom ? zoomKoeff : 1}
          limitToBounds={!isZoom}
        >
          {({ setTransform, resetTransform, ...rest }) => (
            <>
              <div className="tools" hidden>
                <button
                  id="buttonSetTransform"
                  ref={btnRef}
                  onClick={() =>
                    setTransform(
                      helpZoomImageDto.x,
                      helpZoomImageDto.y,
                      helpZoomImageDto.zoom,
                      800,
                      'easeInOutQuart'
                    )
                  }
                >
                  переход
                </button>
                <button
                  ref={btnRef2}
                  onClick={() => resetTransform(800, 'easeInOutQuart')}
                >
                  начало
                </button>
              </div>
              <TransformComponent>
                <Stack
                  width={
                    windowState === WINDOW_V
                      ? window.innerWidth
                      : window.innerWidth / 2
                  }
                  height={
                    windowState === WINDOW_V
                      ? getMaxHeightConst()
                      : getMaxHeightConst2()
                  }
                  style={{ transform: 'unset !important' }}
                  alignItems="center"
                  justifyContent="center"
                >
                  {isZoom &&
                    dto.slideImages[step].images.map((item) => (
                      <>
                        {dto.slideImages[step].type !==
                          IMAGE_TYPE_ZOOM_VIDEO && (
                          <img
                            key={item.name}
                            className={classes.img}
                            width={
                              getImageVideoSize(
                                dto.slideImages[step].zoomImage,
                                windowState === WINDOW_V
                                  ? getMaxHeightConst()
                                  : getMaxHeightConst2(),
                                windowState === WINDOW_V
                                  ? window.innerWidth
                                  : window.innerWidth / 2
                              )[0]
                            }
                            height={
                              getImageVideoSize(
                                dto.slideImages[step].zoomImage,
                                windowState === WINDOW_V
                                  ? getMaxHeightConst()
                                  : getMaxHeightConst2(),
                                windowState === WINDOW_V
                                  ? window.innerWidth
                                  : window.innerWidth / 2
                              )[1]
                            }
                            style={{
                              transform: tranformValue,
                              transition:
                                'transform 0.8s cubic-bezier(0.77, 0, 0.175, 1)',
                              position: getPosition(
                                dto.slideImages[step].type,
                                false
                              ),
                              filter:
                                item.fill === 0
                                  ? 'grayscale(0%)'
                                  : 'grayscale(100%)',
                            }}
                            src={
                              findBase64Image(item.name, dtoImagesBase6444) !==
                              ''
                                ? `data:image/png;base64,${findBase64Image(
                                    item.name,
                                    dtoImagesBase6444
                                  )}`
                                : `https://uchianat.ru/api/contentUrl.php?section=${section}&lectionId=${lectionId}&page=${
                                    dto.id
                                  }&name=${item.name}&${secureContent()}`
                            }
                            alt="not found"
                          />
                        )}
                        {dto.slideImages[step].type === IMAGE_TYPE_ZOOM_VIDEO &&
                          !HasVideoUrlToTheme(item.name, dto.videoUrl) && (
                            <video
                              key={item.name}
                              width={
                                getImageVideoSize(
                                  dto.slideImages[step].zoomImage,
                                  windowState === WINDOW_V
                                    ? getMaxHeightConst()
                                    : getMaxHeightConst2(),
                                  windowState === WINDOW_V
                                    ? window.innerWidth
                                    : window.innerWidth / 2
                                )[0]
                              }
                              height={
                                getImageVideoSize(
                                  dto.slideImages[step].zoomImage,
                                  windowState === WINDOW_V
                                    ? getMaxHeightConst()
                                    : getMaxHeightConst2(),
                                  windowState === WINDOW_V
                                    ? window.innerWidth
                                    : window.innerWidth / 2
                                )[1]
                              }
                              style={{
                                transform: tranformValue,
                                transition:
                                  'transform 0.8s cubic-bezier(0.77, 0, 0.175, 1)',
                                position: getPosition(
                                  dto.slideImages[step].type,
                                  false
                                ),
                                filter:
                                  item.fill === 0
                                    ? 'grayscale(0%)'
                                    : 'grayscale(100%)',
                              }}
                              poster="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII="
                              playsInline
                              autoPlay
                              muted
                              controls={false}
                            >
                              <source
                                src={`https://uchianat.ru/api/contentUrl.php?section=${section}&lectionId=${lectionId}&page=${
                                  dto.id
                                }&name=${item.name}&${secureContent()}`}
                                type="video/mp4"
                              />
                            </video>
                          )}
                        {dto.slideImages[step].type === IMAGE_TYPE_ZOOM_VIDEO &&
                          HasVideoUrlToTheme(item.name, dto.videoUrl) && (
                            <iframe
                              src={
                                curTheme === LIGHT_THEME
                                  ? GetVideoUrlToTheme(
                                      item.name,
                                      curTheme,
                                      dto.videoUrl
                                    )
                                  : GetVideoUrlToTheme(
                                      item.name,
                                      curTheme,
                                      dto.videoUrl
                                    )
                              }
                              allow="autoplay; picture-in-picture; encrypted-media; gyroscope; accelerometer; clipboard-write; screen-wake-lock;"
                              frameBorder="0"
                              style={{
                                transform: tranformValue,
                                transition:
                                  'transform 0.8s cubic-bezier(0.77, 0, 0.175, 1)',
                                position: getPosition(
                                  dto.slideImages[step].type,
                                  false
                                ),
                                filter:
                                  item.fill === 0
                                    ? 'grayscale(0%)'
                                    : 'grayscale(100%)',
                              }}
                              key={item.name}
                              width={getImgWidthVideo()}
                              height={
                                windowState === WINDOW_V
                                  ? getImgWidthVideo()
                                  : getImgWidthVideo()
                              }
                            />
                          )}
                      </>
                    ))}
                  {!isZoom && (
                    <img
                      className={classes.img}
                      width={
                        getImageVideoSize(
                          dto.slideImages[step].zoomImage,
                          windowState === WINDOW_V
                            ? getMaxHeightConst()
                            : getMaxHeightConst2(),
                          windowState === WINDOW_V
                            ? window.innerWidth
                            : window.innerWidth / 2
                        )[0]
                      }
                      height={
                        getImageVideoSize(
                          dto.slideImages[step].zoomImage,
                          windowState === WINDOW_V
                            ? getMaxHeightConst()
                            : getMaxHeightConst2(),
                          windowState === WINDOW_V
                            ? window.innerWidth
                            : window.innerWidth / 2
                        )[1]
                      }
                      src={
                        findBase64Image(
                          dto.slideImages[step].zoomImage.name,
                          dtoImagesBase6444
                        ) !== ''
                          ? `data:image/png;base64,${findBase64Image(
                              dto.slideImages[step].zoomImage.name,
                              dtoImagesBase6444
                            )}`
                          : `https://uchianat.ru/api/contentUrl.php?section=${section}&lectionId=${lectionId}&page=${
                              dto.id
                            }&name=${
                              dto.slideImages[step].zoomImage.name
                            }&${secureContent()}`
                      }
                      alt="not found"
                    />
                  )}
                </Stack>
              </TransformComponent>
            </>
          )}
        </TransformWrapper>
      </div>
    </div>
  );
};

LectionDivImageItem.defaultProps = {
  dtoImagesBase6444: undefined,
};
